import baseUrl from '../../utils/baseUrl';
import getToken from '../../utils/getToken';

interface AddFanProps {
  memberId?: string;
  artistIds: string[];
}

export async function addFan({ artistIds, memberId }: AddFanProps) {
  let resultMember = true;

  if (memberId) {
    const response = await fetch(`${baseUrl()}/artists/${artistIds[0]}/like_member`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`
      },
      body: JSON.stringify({ member_id: memberId })
    });
    resultMember = response.ok;
  }

  const results = await Promise.all(
    artistIds.map((artistId) => {
      return fetch(
        `${baseUrl()}/api/v1/artists/${artistId}/like${!memberId ? '?like_all=true' : ''}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
    })
  );
  const resultArtist = results.every((result) => result.ok);

  return resultMember && resultArtist;
}
